export default "__VITE_ASSET__f2d415ba__"